import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from '../../../services/messaging/notification.service';
import { AuthenticationService } from '../../../modules/auth/services/authentication.service';
import { TdoUserConfigurationModel } from '../../../models/configuration/user/tdo-user-configuration.model';
import { ColorSchemeDataModel } from '../../../models/configuration/color-scheme-data.model';
import { ColorSchemesService } from '../../../modules/configuration/color-schemes/color-schemes.service';
import { NotificationDataModel } from '../../../models/messaging/notification-data.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  NotificationCreateDialogComponent
} from '../../../dialog/notifications/notification-create-dialog/notification-create-dialog.component';
import { NotificationDestinationDataModel } from '../../../models/messaging/notification-destination-data.model';
import { UiService } from '../../../services/ui.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'tdo-instant-messaging',
  templateUrl: './tdo-instant-messaging.component.html',
  styleUrls: ['./tdo-instant-messaging.component.scss']
})
export class TdoInstantMessagingComponent implements OnInit {
  @Input() isDisableHeader: boolean = false;
  @Input() isMinimized: boolean = false;
  colorSchemes: ColorSchemeDataModel[] = [];
  users: TdoUserConfigurationModel[] = [];

  constructor(public notificationService: NotificationService,
    private readonly uiService: UiService,
    private readonly userService: UserService,
    private readonly authenticationService: AuthenticationService,
    private readonly colorSchemeService: ColorSchemesService,
    private readonly dialog: MatDialog) { }

  ngOnInit(): void {
    this.userService.getUsers(this.authenticationService.currentUserValue.TDOCID).subscribe((users) => {
      this.users = users;
    });

    this.colorSchemeService.getColorSchemes().subscribe((cs) => {
      this.colorSchemes = cs;
    });

    this.notificationService.messageUpdate.subscribe(() => {
      this.playSound(this.authenticationService.currentUserValue.userid);
    });
  }

  getInstantMessages() {
    this.notificationService.getMessagesForUser(this.authenticationService.currentUserValue.authdata.userid).subscribe((notifications) => {

    });
  }

  getBackgroundColor(userId: string) {
    if (this.users) {
      const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
      if (user) {
        const scheme = this.colorSchemes.find(p => p.ColorSchemeId.toLowerCase() === user?.ColorSchemeID?.toLowerCase());
        if (scheme) {
          return scheme.BackColor;
        }
      }
    }
    return "white";
  }

  getForColor(userId: string) {
    if (this.users) {
      const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
      if (user) {
        const scheme = this.colorSchemes.find(p => p.ColorSchemeId.toLowerCase() === user?.ColorSchemeID?.toLowerCase());
        if (scheme) {
          return scheme.ForeColor;
        }
      }
    }
    return "black";
  }

  getName(userId: string) {
    if (this.users) {
      if (userId.toLowerCase() === this.authenticationService?.currentUserValue?.authdata?.userid?.toLowerCase()) {
        return 'Me';
      }
      const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
      if (user) {
        let ret = user.FirstName;
        if (user.LastName) {
          ret += ' ' + user.LastName;
        }
        return ret;
      }
    }
  }

  playSound(userId: string) {
    if (this.users) {
      const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
      if (user) {
        const audio = new Audio();
        audio.src = 'assets/sounds/user/' + user.UserSound;
        audio.load();
        audio.play();
      }
    }
  }

  onNotificationSeenClick(notification: NotificationDataModel, b: boolean) {
    this.notificationService.markNotificationAsSeen(notification).subscribe((res) => {
      let idx = -1;
      idx = this.notificationService.instantMessages.findIndex(p => p.dataNotification.NotificationID === notification.NotificationID);
      if (idx > -1) {
        this.notificationService.instantMessages.splice(idx, 1);
      }
    });
  }

  onOpenInstantMessaging(destination: NotificationDestinationDataModel = null) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = destination;
    this.dialog.open(NotificationCreateDialogComponent, config);
  }

  getInitials(userId: string) {
    if (this.users) {

      const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
      if (user) {
        let ret = user.FirstName.charAt(0);
        if (user.LastName) {
          ret += user.LastName.charAt(0);
        }
        return ret;
      }
    }
  }

  getDate(s: string) {
    const d = new Date(s);
    return d.toLocaleString();
  }
}
